// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_InfoCard_titleWithTooltip__2mgYk {
  display: flex;
  align-items: center;
  gap: 4px;
}

.storage_InfoCard_tooltipIcon__xKPnB {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/components/InfoCards/InfoCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf","sourcesContent":[".titleWithTooltip {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.tooltipIcon {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleWithTooltip": `storage_InfoCard_titleWithTooltip__2mgYk`,
	"tooltipIcon": `storage_InfoCard_tooltipIcon__xKPnB`
};
export default ___CSS_LOADER_EXPORT___;
